var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideoBlock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBlock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Call-incoming---start",
    transform: "translate(-68.000000, -519.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(30.000000, 431.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(25.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icBlockUser"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4515625,16.5484375 C35.715625,18.8124531 37,21.8077656 37,25 C37,31.6286406 31.5768438,37 25,37 C18.3941406,37 13,31.6074062 13,25 C13,18.3960625 18.4067031,13 25,13 C28.1922344,13 31.1875,14.2844219 33.4515625,16.5484375 Z M25.0615739,34.0909091 C27.0329249,34.0909091 28.9055698,33.4713564 30.4545455,32.3166885 L17.6691838,19.5454545 C16.5286436,21.0943363 15.9090909,22.9670751 15.9090909,24.9384261 C15.9090909,30.0081976 20.0025507,34.0909091 25.0615739,34.0909091 Z M32.3167355,30.4545455 C33.4713564,28.9056537 34.0909091,27.0329028 34.0909091,25.061633 C34.0909091,19.9918287 29.9975901,15.9090909 24.9384261,15.9090909 C22.9670751,15.9090909 21.0944302,16.5286476 19.5454545,17.6691952 L32.3167355,30.4545455 Z",
    id: "icBlock",
    transform: "translate(25.000000, 25.000000) scale(-1, 1) translate(-25.000000, -25.000000) "
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoBlock);
export default __webpack_public_path__ + "static/media/icVideoBlock.fdc643fef1d8f551af7942482ce1f62b.svg";
export { ForwardRef as ReactComponent };